<template>
  <div class="form-builder">
    <md-content>
      <!-- <textarea v-if="dev_mode" id="form_builder_test_json"></textarea> -->
      <viewer
        v-if="view_mode && !preview_mode"
        :nid="nuuid"
        :sid="suuid"
        @set-sid="suuid = $event"
      />
      <view-builder :noTemplate="noTemplate" v-else-if="!preview_mode" />
      <preview v-else-if="preview_mode" :pmode="preview_mode" />
    </md-content>
  </div>
</template>

<script>
export default {
  name: "Temporary",
  props: ["mode", "nid", "sid", "noTemplate"],
  mounted() {
    let selectTemplates = this.$el.closest(".details-wrapper")
      ? this.$el.closest(".details-wrapper").querySelectorAll("input.form-autocomplete")
      : {};
    [].forEach.call(selectTemplates, (item) => {
      // this.enablePreview(item);
      this.selectTemplateLinstener(item);
    });
  },
  data() {
    return {
      preview_mode: false,
      showNavigation: false,
      view_mode: this.mode || false,
      dev_mode: window.webpackHotUpdate,
      nuuid: this.nid || "",
      suuid: this.sid || "",
    };
  },
  components: {
    //builder: () => import("./views/Builder.vue"),
    //viewer: () => import("./views/Viewer.vue"),
    //preview: () => import("./views/Preview.vue")
  },
  methods: {
    enablePreview(field) {
      if (field.value != "") {
        this.preview_mode = true;
      }
    },

    selectTemplateLinstener(field) {
      field.addEventListener("change", (event) => {
        var selectElement = event.target;
        if (selectElement.value != "") {
          this.preview_mode = true;
        } else {
          let textarea =
            this.$el.parentElement.parentElement.querySelector("textarea") ||
            document.querySelector("#form_builder_test_json");
          textarea.value = "";
          this.preview_mode = false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.md-menu-content {
  z-index: 103 !important;
}

.text-left {
  text-align: left;
}

.form-builder {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  text-align: center;
  color: #2c3e50;
  //overflow: hidden;
  position: relative;
  label {
    font-weight: 400;
  }
}

.md-dialog {
  label {
    font-weight: 400;
  }
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
